import { WavyDivider } from '../components/Decorations';
import { Reveal } from '../components/Reveal';
import { Accent, SectionHeading } from '../components/SectionHeading';
import { strengths } from '../content/credentials';

export function Strengths() {
  return (
    <>
      <WavyDivider className="-mb-px text-mint-50" flip />
      <section className="bg-mint-50 px-6 py-20 sm:px-8 sm:py-24">
        <div className="mx-auto max-w-6xl">
          <Reveal>
            <SectionHeading eyebrow="What I bring">
              How I look after <Accent>your little ones</Accent>.
            </SectionHeading>
          </Reveal>

          <ul className="mt-14 grid gap-6 lg:grid-cols-3">
            {strengths.map((strength, index) => (
              <Reveal key={strength.title} delay={index * 110} as="li">
                <div className="h-full rounded-blob bg-white p-8 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:shadow-lift motion-reduce:hover:translate-y-0">
                  <span
                    aria-hidden="true"
                    className="flex h-14 w-14 items-center justify-center rounded-full bg-mint-100 text-2xl"
                  >
                    {strength.emoji}
                  </span>
                  <h3 className="mt-6 text-xl">{strength.title}</h3>
                  <p className="mt-3 leading-relaxed">{strength.body}</p>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
      <WavyDivider className="-mt-px text-mint-50" />
    </>
  );
}
